var _style, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGreenCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "Layer_1",
  x: 0,
  y: 0,
  viewBox: "0 0 360 360"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#6ca442}.st1{fill:#fff}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 178.14,
  cy: 181.49,
  r: 175.5,
  className: "st0"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M129.81 307.34 11.41 188.95l46.23-46.23 72.17 72.16L280.9 63.79l46.23 46.23z",
  className: "st1"
})));
export { SvgGreenCheck as ReactComponent };
export default __webpack_public_path__ + "aa4d4cff40ceabe382213711a84ca008.svg";